import { accordion } from './accordion';
import { alert } from './alert';
import { autocomplete } from './autocomplete';
import { avatarGroup } from './avatarGroup';
import { button } from './button';
import { card } from './card';
import { chip } from './chip';
import { datePickers } from './datePickers';
import { formControl } from './formControl';
import { menu } from './menu';
import { radio } from './radio';
import { select } from './select';
import { stepper } from './stepper';
import { tab } from './tab';
import { textfield } from './textfield';
import { tooltip } from './tooltip';

export const muiComponents = {
  ...accordion,
  ...alert,
  ...card,
  ...chip,
  ...autocomplete,
  ...avatarGroup,
  ...button,
  ...datePickers,
  ...formControl,
  ...menu,
  ...radio,
  ...select,
  ...stepper,
  ...textfield,
  ...tooltip,
  ...tab
};
